
export default [
  {
    path: '/videolist',
    name: 'videolist',
    component: () => import('@/components/videoclass/videolist'),
  },
  {
    path: '/courseplayer',
    name: 'courseplayer',
    component: () => import('@/components/videoclass/courseplayer'),
  },
  {
    path: '/coursemore',
    name: 'coursemore',
    component: () => import('@/components/videoclass/coursemore'),

  }
]